module.exports = __webpack_public_path__ + "img/wave.57bb8213.png";